import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ImageAltText extends BaseOption {
  static userInterfaceComponent = {
    label: "Alt Text",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "textarea",
      placeholder: "Describe the image",
    },
  };

  static defaultValue = "";
}
